<template>
<div id="contents">
  <div class="dg-pop-layer pop-wd-wide st-poeple-dtl on" id="popPeopleDtlBox" v-if="popupTap=='detail'">
    <div class="dg-pop-hd-st2-box">
      <div class="pop-h1">회원정보</div>
      <div class="btn-close-box"><a href="javascript:;" class="btn-close" @click="closePopup">닫기</a></div>
    </div>
    <div class="pop-cont-box pop-people-info-box">
      <div class="img-box"> 
        <img class="member-list-box" v-if="userDetail.photoFile==null" src="@/assets/images/icon/member.jpg"/>
        <img class="member-list-box" v-else :src="`${attachFileServerUrl}/user/photo/${userDetail.photoFile}`" @error="(e) => e.target.src=require('@/assets/images/icon/member.jpg')"/>
        
      </div>
      <div class="data-box">
        <div class="tb-01 st-w">
          <table>
            <colgroup><col width="140px"><col width="210px"><col width="140px"><col width="210px"></colgroup>
            <tbody>
            <tr>
              <th>이름</th>
              <td>{{ userDetail.name }}</td>
              <th>아이디</th>
              <td :style="userDetail.userId.length>15 ? `font-size:12px` : ''">{{ userDetail.userId }}</td>
            </tr>
            <tr>
              <th>생년월일</th>
              <td>{{ userDetail.birthDate }}</td>
              <th>휴대폰 번호</th>
              <td>{{ phoneFormatter(userDetail.mobileNo) }}</td>
            </tr>
            <tr>
              <th>이메일</th>
              <td colspan="3">{{ userDetail.email }}</td>
            </tr>
            <tr>
              <th>자택주소</th>
              <td colspan="3">{{ userDetail.address }} {{ userDetail.addressDetail }}</td>
            </tr>
            <tr>
              <th>현재 직장</th>
              <td>{{ userDetail.company }}</td>
              <th>현재 직책</th>
              <td>{{ userDetail.position }}</td>
            </tr>
            <tr>
              <th>최종부서<br>(전자 재임시)</th>
              <td>{{ userDetail.retirementDepartment }}</td>
              <th>직위<br>(전자 재임시)</th>
              <td>{{ userDetail.retirementPosition }}</td>
            </tr>
            <tr>
              <th>분과</th>
              <td colspan="3">{{ userDetailDepartment }}</td>
            </tr>
            <tr>
              <th>동호회</th>
              <td colspan="3">{{ userDetailClubs }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>


  <div class="dg-pop-layer pop-wd-wide st-memo-send on" id="popMemoSendBox" v-if="popupTap=='message'">
    <div class="dg-pop-hd-st2-box">
      <div class="pop-h1">쪽지보내기</div>
      <div class="btn-close-box"><a href="javascript:;" class="btn-close" @click="closePopup">닫기</a></div>
    </div>
    <div class="pop-cont-box pop-memo-send-box">
      <div class="memo-hd-box">
        <span>받는사람</span>
        <strong>{{ userDetail.name }} 님</strong>
      </div>
      <div class="memo-body-box">
        <textarea v-model="message" cols="30" rows="10" placeholder="메시지를 입력해주세요."></textarea>
        <div class="count-box"> {{ this.message.length }} / 1000</div>
      </div>
      <div class="btn-box"><a href="javascript:;" class="" @click="onClickSend">보내기</a></div>
    </div>
  </div>


  <div class="dg-pop-layer pop-wd-wide st-memo-send on" id="popDivisionCountBox" v-if="popupTap=='list'">
    <div class="dg-pop-hd-st2-box st-flex">
      <div class="pop-h1">{{ groupDetail.parentId == 1? '분과':'동호회'}}인원 <span class="txts">{{ groupDetail.groupName }}</span></div>
      <div class="btn-close-box"><a href="javascript:;" class="btn-close dg-pop-close" @click="closePopup">닫기</a></div>
    </div>
    <div class="pop-cont-box pop-divisioncount-box">
      <div class="row-box">
        <div class="tit-box">역대 운영위원</div>
        <div class="txt-box">
          <ul>
            <li><div class="tit-s">위원장</div> <p v-for="generation in chairman" :key="generation.leaderId">{{ generation.leaderName }}({{ generation.tenure }})</p><p></p></li>
            <li><div class="tit-s">간사</div> <p v-for="generation in secretary" :key="generation.leaderId">{{ generation.leaderName }}({{ generation.tenure }})</p></li>
          </ul>
        </div>
      </div>
      <div class="row-box">
        <div class="tit-box">총 <strong>{{ totalElements }}</strong> 명</div>
        <div class="data-list-box ">
          <ul class="iscroll3">
            <li v-for="user in userList" :key="user.userId" style="position: relative">
              <a href="javascript:;" class="btnPeopleDtl" style="position:initial" @click="onClickDetail(user.userId)">
                <em class="icon-new" style="left: 0;top: 2px;" v-if="isNew(user.createdAt)"></em>
                {{user.name}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- 회원 검색 리스트 -->
  <div class="dg-pop-layer pop-wd-wide st-memo-send on" id="popDivisionCountBox" v-if="popupTap=='memberlist'">
    <div class="dg-pop-hd-st2-box st-member-sch">
      <div class="pop-h1"> 회원조회</div>
      <div class="search-box">
        <input type="text" v-model="param.searchKeyword" placeholder="검색어를 입력해주세요." class="input-st1 wd240 mr10" @keydown="onKeydown">
        <a href="javascript:;" class="btn-s" @click="onClickBeforeSearch">검색</a>
      </div>
      <div class="btn-close-box"><a href="javascript:;" class="btn-close dg-pop-close" @click="closePopup">닫기</a></div>
    </div>
    <div class="pop-cont-box pop-divisioncount-box">
      <div class="row-box">
        <div class="board-search-wrap st5">
          <div class="rs-cnt-box">총 <em class="st2">{{ memberList.totalElements }}</em> 명</div>
          
        </div>
 
        <div class="tb-list-li-box iscroll3">
          <ul class="tb-tit-box">
            <li>번호</li>
            <li>사진</li>
            <li>이름</li>
            <li>분과</li>
            <li>동호회</li>
            <li>선택</li>
          </ul>
          <ul class="tb-txt-box" v-for="(member, idx) in memberList.content" :key="idx"  >
            <li>{{ idx + 1 + ((pagination.currentPage-1) * pagination.pageSize) }}</li>
            <li>
              <img class="member-list-box" v-if="member.photoFile==null" src="../../assets/images/icon/member.jpg"/>
              <img class="member-list-box" v-else :src="`/attachment/user/photo/${member.photoFile}`" @error="(e) => e.target.src=require('@/assets/images/icon/member.jpg')"/>
            </li>
            <li>
              <a href="javascript:;" class="btnPeopleDtlOver">
                <span class="icon-new st2" v-if="isNew(member.createdAt)"></span> {{ member.name }}
              </a>
            </li>
            <li>{{ memberSubdivision(member.departmentGroup) }}</li>
            <li>{{ memberClub(member.clubGroup )}}</li>
            <li><a href="javascript:;" @click="onClickTargetUser(member)" class="btn-file-up wd-sm">선택</a></li>
          </ul> 
        </div>  
        <!-- class : pagination (S) -->
        <DgPagination v-model="pagination" :value="memberList" @pageSelected="pageSelected"/>
        <!-- class : pagination (E) -->
      </div>  
    </div>
  </div>
  <!-- 회원 검색 리스트 -->
  



</div>
</template>

<script>
import userApi from "@/api/UserApi";
import groupApi from "@/api/GroupApi";
import noteApi from "@/api/NoteApi";
import generationLeaderApi from "@/api/GenerationLeaderApi";
import DgPagination from '@/views/component/DgPagination';

export default {
  name: "CommonPopup",
  components:{
    DgPagination
  },
  data(){
    return {
      popupTap: this.tap,
      groupDetail: {},

      generationList: [],
      chairman:[],
      secretary:[],
      userList: [],
      totalElements: 0,
      userDetail: {},
      userDetailDepartment: '',
      userDetailClubs: '',
      message: '',

      param: {
        searchColumn: 'all',
        searchKeyword: null,
        searchDepartment:'',
        searchClub:'',
        page: 1
      },

      memberList:[],
      pagination:{
        currentPage: 1,
        pageSize:5,
        pageGroupSize: 10,
        totalPages:0,
        totalElements:0
      },
      targetUser:{},  
      attachFileServerUrl: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,    
    }
  },
  created(){ 
    if(this.userId != null) {
      this.getUserDetail()
    }else if(this.groupId != null){
      this.getGroupUsers()
    }

    if(this.groupId!=null) {
      groupApi.getGroup(this.groupId).then(data=>{
        this.groupDetail = data;
      })

      generationLeaderApi.list(this.groupId).then(data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].groupPosition == 'chairman') {
            this.chairman.push(data[i])
          } else {
            this.secretary.push(data[i])
          }
        }
        this.generationList = data;
      });
    }
  },
  props:{
    tap:{
      type:String,
      default:null,
    },
    groupId:{
      type:Number
    },
    userId:{
      type:String
    },
    targetUserInfo:{
      type:String
    }
  },
  methods:{
    getUserDetail(){
      this.userDetailClubs=''

      userApi.get(this.userId).then((data) =>{
        this.userDetail = data
        this.userDetailDepartment = data.departmentGroup[0].groupName

        if(data.clubGroup != null) {
          for (let i = 0; i < data.clubGroup.length; i++) {
            this.userDetailClubs += data.clubGroup[i].groupName
            if (i < data.clubGroup.length - 1) {
              this.userDetailClubs += ", "
            }
          }
        }
      })
    },
    getGroupUsers(){
      //그룹회원조회
      const params = {
        size:1000
      }
      //params.searchGroup = this.groupId
      params.searchGroup = this.groupId
      params.page = 1
      userApi.groupUsers(params).then((data) => {
        this.userList = data.content
        this.totalElements = data.totalElements
      })
    },
    getMemberList(){
      //회원조회
      const params = {size:1000};

      params.fromDate = null;
      params.toDate = null;
      params.searchState = 'STATE_NORMAL'
      params.size = this.pagination.pageSize
      params.page = this.pagination.currentPage
      userApi.list(params).then(data => {
        this.memberList = data;
        this.pagination.totalElements=data.totalElements
        let totalPages = Math.floor(data.totalElements / this.pagination.pageSize) + ((data.totalElements % this.pagination.pageSize) > 0 ? 1 : 0) ;
        this.pagination.totalPages = totalPages;
      })
    },
    onClickBeforeSearch(){
      this.pagination={
        currentPage: 1,
        pageSize:10,
        pageGroupSize: 10,
        totalPages:0,
        totalElements:0
      },

      delete this.param.searchColumn;
      this.onClickSearch();
    },
    onClickSearch(){
      const params = {...this.param};

      params.fromDate = null;
      params.toDate = null;
      params.searchState = 'STATE_NORMAL'
      params.size = this.pagination.pageSize
      params.page = this.pagination.currentPage
      userApi.list(params).then(data => {
        this.memberList = data;
        this.pagination.totalElements=data.totalElements
        let totalPages = Math.floor(data.totalElements / this.pagination.pageSize) + ((data.totalElements % this.pagination.pageSize) > 0 ? 1 : 0) ;
        this.pagination.totalPages = totalPages;
      })
    },
    onKeydown(e){
      if(e.keyCode===13){
        this.onClickBeforeSearch();
      }
    },
    pageSelected(pagination){
      this.pagination.currentPage = pagination.currentPage;
      this.onClickSearch();
    },
    onMouseOver(idx){
      this.overIdx=idx;
    },
    onMouseLeave(){
      this.overIdx=null;
    },
    onClickTargetUser(targetUser){  
      this.$emit('click:targetUserSelect',targetUser);
      this.closePopup();
    },
    closePopup(){
      if(this.tap != this.popupTap){
        this.popupTap = this.tap
      }else {
        this.$emit('click:bgDimClose', false)
      }
    },
    onClickDetail(val){
      this.popupTap = 'detail'
      this.userId = val
      this.getUserDetail()
    },
    onClickSend(){
      let reciever = [{'userId':this.userId,
                       'receiverName':this.userDetail.name}]
      reciever.push()
      let params = {
        'noteContent':this.message,
        'noteReceiveUsers':reciever
      }
      noteApi.save(params).then(()=>{
        alert('쪽지를 전송하였습니다.');
        this.message='';
        this.closePopup();
      })
    },
    phoneFormatter(val) {
      if (val != null) {
        if (val.length == 11) {
          return val.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else if (val.length == 8) {
          return val.replace(/(\d{4})(\d{4})/, "$1-$2");
        } else {
          if (val.indexOf("02") == 0) {
            return val.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
          } else {
            return val.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
          }
        }
      }
    },
    isNew(val) {
      //오늘로부터 6개월 내에 가입한 사람은 new 아이콘
      let moment = require('moment')
      let createdAt = moment(val)

      let calculDate = moment().subtract(6,'M')
      return createdAt > calculDate? true:false
    },
    memberClub(val){
      if(val!=null) {
        let clubLength = val.length
        let userClubs = clubLength > 0 ? val[0].groupName : ''
        if (clubLength > 1) {
          userClubs += " 외 " + (clubLength - 1)
        }
        return userClubs
      }
    },
    memberSubdivision(val){
      if(val!=null) {
        let subdivisionLength = val.length
        let userSubdivision = subdivisionLength > 0 ? val[0].groupName : ''
        return userSubdivision
      }
    },
  },
  watch:{
  }
}
</script>

<style scoped>
.v-application a{color:#333333}
.tb-01.st-w tbody th{font-size: 12px;padding:10px;}
.tb-01.st-w tbody td{text-align: left !important;}
.tb-list-li-box{overflow-y:auto;height: 420px;margin-bottom: 20px;}
.tb-list-li-box .tb-tit-box{display: flex; justify-content: space-between;    align-items: center;    background: #f8f8f8;
    height: 55px;    line-height: 55px;    border-bottom: 1px solid #dfdfdf;    font-weight: 500;    font-size: 17px;    color: #333333;border-top:1px solid #333333}
.tb-list-li-box .tb-txt-box{display: flex; justify-content: space-between;    align-items: center;    padding: 12px 0 12px 0;
    min-height: 44px;    box-sizing: border-box;    border-bottom: 1px solid #eeeeee;}
.tb-list-li-box li{text-align:center}
.tb-list-li-box li:first-child{width:10%}
.tb-list-li-box li:nth-child(2){width:14%}
.tb-list-li-box li:nth-child(3){width:15%}
.tb-list-li-box li:nth-child(4){width:23%}
.tb-list-li-box li:nth-child(5){width:23%}
.tb-list-li-box li:nth-child(6){width:15%}

</style>